import styled from 'styled-components';
import { motion } from 'framer-motion';

export const StyledTooltip = styled(motion.div)`
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background-color: ${({ background }) => background};
  border: none;
  border-radius: ${({ zoom }) => 12 * zoom}px;
  z-index: 1000000000000;
  padding: ${({ zoom }) => `${18 * zoom}px ${26 * zoom}px`};
  text-align: center;
  color: ${({ theme }) => theme.color.baliHai};
  font-size: ${({ zoom }) => 12 * zoom}px;
  font-weight: 600;
  line-height: ${({ zoom }) => 15 * zoom}px;
  /* box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px; */
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px; */
  /* box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px; */
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
`;
